function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import set from 'lodash/set';
import { filter, includes, unset } from 'lodash';
import Validator from 'libs/Validator';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import CheckboxRadio from 'components/Form/CheckboxRadio';
import Input from 'components/Form/Input';
import Button from 'components/Form/Button';
import FormContainerAbstract from 'components/FormContainerAbstract';
import App from 'modules/App';
import Account from 'modules/Account';
import { SCOPE_NAMES } from 'modules/Account/constants';
import messages from '../../../../../../messages';
import * as constants from '../../../../../../constants';
import validatorRules from './validatorRules.json';
class UpdateOrAddIdentifierOptionForm extends FormContainerAbstract {
    get assignmentIds() {
        return [
            constants.IDENTIFIER_TERM_TYPES.PERSONAL,
            constants.IDENTIFIER_TERM_TYPES.LICENCE,
            constants.IDENTIFIER_TERM_TYPES.ORGANIZATION
        ];
    }
    get identifierNames() {
        return get(this.props.formValues, 'values.identifierNames', []);
    }
    onValidate(rules) {
        const values = get(this.props.formValues, 'values', {});
        const { errors } = Validator.run(values, rules);
        if (!this.props.isNew || get(errors, 'termKey.alreadyExist', false) && !includes(this.existingTermKeys, values.termKey)) {
            unset(errors, 'termKey.alreadyExist');
            unset(errors, 'termKey');
        }
        if (!get(values, 'slaveRegExp')) {
            set(values, 'slaveRegExp', '');
        }
        return {
            validatedValues: values,
            errors: !errors || Object.keys(errors).length ? errors : null
        };
    }
    onSetIdentifierNames(assignmentId) {
        let values = this.identifierNames;
        if (values.includes(assignmentId)) {
            values = filter(values, (value)=>value !== assignmentId);
        } else {
            values = [
                ...values,
                assignmentId
            ];
        }
        this.props.onSetFormValue({
            id: 'identifierNames',
            value: values
        });
    }
    renderHeader() {
        const info = this.props.isNew ? messages.infos.addNewIdentifierOption : messages.infos.updateIdentifierOption;
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx("p", {
                className: "mb-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, info))
            })
        });
    }
    renderActions() {
        const confirmLabel = this.props.isNew ? messages.buttons.addNew : messages.buttons.update;
        return /*#__PURE__*/ _jsxs("div", {
            className: "row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "reset",
                        styleModifier: "primary",
                        labelMessage: App.messages.buttons.cancel,
                        className: "btn--block",
                        onClick: this.props.onClose
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-6",
                    children: /*#__PURE__*/ _jsx(Button, {
                        type: "submit",
                        styleModifier: "primary",
                        labelMessage: confirmLabel,
                        className: "btn--block btn--filled",
                        isDisabled: this.isDisabled,
                        isInProgress: this.state.isInProgress
                    })
                })
            ]
        });
    }
    renderForm() {
        return /*#__PURE__*/ _jsxs(Form, {
            onSubmit: ()=>this.onSubmit(),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "row mb-8",
                    children: /*#__PURE__*/ _jsx(FormGroup, {
                        id: "termKey",
                        className: "col-12",
                        labelMessage: messages.identifierTab.labels.termKey,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            isDisabled: !this.props.isNew,
                            onChange: (input)=>this.onSetValue(input)
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row mb-8",
                    children: /*#__PURE__*/ _jsx(FormGroup, {
                        id: "labelValue",
                        className: "col-12",
                        labelMessage: messages.identifierTab.labels.name,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            onChange: (input)=>this.onSetValue(input)
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "row mb-8",
                    children: /*#__PURE__*/ _jsx(FormGroup, {
                        id: "instructionsValue",
                        className: "col-12",
                        labelMessage: messages.identifierTab.labels.validationRule,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            onChange: (input)=>this.onSetValue(input)
                        })
                    })
                }),
                this.props.isSDNAdmin && /*#__PURE__*/ _jsx("div", {
                    className: "row mb-8",
                    children: /*#__PURE__*/ _jsx(FormGroup, {
                        id: "slaveRegExp",
                        className: "col-12",
                        labelMessage: messages.identifierTab.labels.regExp,
                        formValues: this.props.formValues,
                        children: /*#__PURE__*/ _jsx(Input, {
                            onChange: (input)=>this.onSetValue(input)
                        })
                    })
                }),
                this.renderTermAssignment(),
                this.renderActions()
            ]
        });
    }
    renderTermAssignment() {
        return /*#__PURE__*/ _jsx("div", {
            className: "d-flex",
            children: this.assignmentIds.map((assignmentId)=>this.renderCheck(assignmentId))
        });
    }
    renderCheck(termKey) {
        return /*#__PURE__*/ _jsx(CheckboxRadio, {
            className: "mr-4",
            id: `createIdentifier-${termKey}`,
            inputValue: "true",
            labelMessage: messages.identifierTab.labels[termKey],
            onChange: ()=>this.onSetIdentifierNames(termKey),
            value: includes(this.identifierNames, termKey) ? 'true' : 'false'
        }, `createIdentifier-${termKey}`);
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderHeader(),
                this.renderForm()
            ]
        });
    }
    constructor(props){
        super(props);
        this.validatorRules = _object_spread({}, validatorRules);
        this.state = {
            isInProgress: false
        };
        this.existingTermKeys = this.props.existingTermKeys;
        const defaultValue = {
            identifierNames: []
        };
        props.onSetFormValues(_object_spread({}, defaultValue, props.initialFormValue));
    }
}
_define_property(UpdateOrAddIdentifierOptionForm, "propTypes", _object_spread_props(_object_spread({}, FormContainerAbstract.propTypes), {
    // Explicit actions
    onSubmit: PropTypes.func,
    onClose: PropTypes.func,
    isNew: PropTypes.bool
}));
const mapStateToProps = (state)=>({
        formValues: App.selectors.formSelector(constants.ADD_IDENTIFIER_OPTION_FORM)(state),
        isSDNAdmin: Account.selectors.scope(state) === SCOPE_NAMES.SDN_ADMIN
    });
const mapDispatchToProps = (dispatch)=>{
    const formName = constants.ADD_IDENTIFIER_OPTION_FORM;
    return {
        onSetFormValue: (input)=>dispatch(App.actions.setFormValue(formName, input)),
        onSetFormValues: (values)=>dispatch(App.actions.setFormValues(formName, values)),
        onFormErrors: (errors)=>dispatch(App.actions.setFormErrors(formName, errors)),
        onFormProcessing: ()=>dispatch(App.actions.startFormProcessing(formName)),
        onClearForm: ()=>dispatch(App.actions.clearForm(formName))
    };
};
const ConnectedUpdateOrAddIdentifierOptionForm = connect(mapStateToProps, mapDispatchToProps)(UpdateOrAddIdentifierOptionForm);
export default ConnectedUpdateOrAddIdentifierOptionForm;
